export default __webpack_public_path__ + "static/media/header_12.01dcf5b1.jpg";